import api from 'api/axios';

export const getPmjayList = async (payload) => {
  return api.post("/pmjay/list", payload);
};

export const getPmjayById = async (id) => {
  return api.get(`/pmjay/${id}`);
};

export const addPmjayPackage = async (payload) => {
  return api.post("/pmjay/", payload);
};

export const updatePmjayPackage = async (id, payload) => {
  return api.patch(`/pmjay/${id}`, payload);
};

export const deletePmjayPackage = async (id) => {
  return api.delete(`/pmjay/${id}`);
};

export const importPmjayBulk = async (formData) => {
  return api.post("/pmjay/import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getPmjayImportLogs = async (params) => {
  return api.get("/pmjay/import-logs", { params });
};
